module.exports = __webpack_public_path__ + "static/media/hollow_bar_M2_tall.52992865.svg";